import React from 'react'

import './styles.scss'

const closeHander = (closeFn = () => {}) => event => {
    if (
        !event
        || event.type === 'click'
        || (['keydown', 'keypress'].includes(event.type) && event.key === 'Escape')
    ) {
        closeFn.call(this, event)
    }
}

export const ToastMessage = ({ closeToast, icon = 'check', children }) => (
    <div className="toast-content">
        <i className={`cell icon fa fa-${icon}`} />
        <div className="cell main">{ children }</div>
        <i
            className="cell icon fa fa-close"
            role="button"
            tabIndex="0"
            onKeyDown={closeHander(closeToast)}
            onClick={closeHander(closeToast)} />
    </div>
)

export default ToastMessage
